import React, { useState, useEffect } from 'react'
import { Formik, Form, FieldArray } from 'formik'
import { Link, useParams } from 'react-router-dom'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { InputCheckboxNullable } from '../../../../components/InputsV2'
import { InputTipoPergunta } from '../../../../components/InputsAutoComplete'
import { HeaderCadastro } from '../../../../components/Headers'
import { BotaoPadrao } from '../../../../components/Botoes'
import { ModalDuasOpcoes } from '../../../../components/Modais'
import { mostrarToast } from '../../../../components/Toasts'
import { mensagens } from '../../../../util/Utilitarios'
import { TIPO_PERGUNTA } from '../../../../util/Enums'
import Yup from '../../../../util/Validacoes'
import { salvar, get } from '../../../../util/AcessoApi'
import CampoTexto from '../components/CampoTexto'
import '../../../../assets/css/icones/iconsmind/style.css'
import '../../../../assets/css/tabs.css'
import '../css/formulario.css'

const gerarChave = () => Math.random().toString(36).slice(2)

const novaOpcao = () => ({ descricao: '' })
const novaPergunta = () => ({ _chave: gerarChave(), descricao: '', tipo_pergunta: null, placeholder: '', mostrar_nao_possui: true, qtd_respostas: 0, ativo: false, opcoes: [] })
const novoGrupo = () => ({ _chave: gerarChave(), descricao: '', ativo: false, perguntas: [] })

const ehComentario = pergunta => pergunta && pergunta.tipo_pergunta && parseInt(pergunta.tipo_pergunta.value) === TIPO_PERGUNTA.COMENTARIO

const idLinha = chave => 'fpa-pergunta-' + chave

const grupoTemResposta = grupo => (grupo.perguntas || []).some(pergunta => pergunta.qtd_respostas > 0)

const Cadastro = props => {
    let { id } = useParams()

    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({ grupos: [] })
    const [abaAtiva, setAbaAtiva] = useState(0)
    const [expandidas, setExpandidas] = useState({})
    const [linhaNova, setLinhaNova] = useState(null)
    const [confirmacao, setConfirmacao] = useState(null)
    const [validacao] = useState(Yup.object({
        grupos: Yup.array().of(Yup.object({
            descricao: Yup.string().required().nullable().max(100).trim(),
            perguntas: Yup.array().of(Yup.object({
                descricao: Yup.string().required().nullable().max(200).trim(),
                tipo_pergunta: Yup.string().required().nullable(),
                placeholder: Yup.string().nullable().max(100),
                opcoes: Yup.array().of(Yup.object({
                    descricao: Yup.string().nullable().max(120)
                }))
            }))
        }))
    }))

    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>Pré-Anestésico</span>,
        () => <Link className='link-active' to={'/preanestesico/formulario/consulta'}>Formulários</Link>,
    ]

    useEffect(() => {
        Promise.resolve(get(`/preanestesico/formulario/${id || 0}`)).then(obj => {
            if (!obj || !obj.id) {
                props.history.push('/preanestesico/formulario/consulta')
                return
            }

            setValoresIniciais({
                ...obj,
                grupos: (obj.grupos || []).map(grupo => ({
                    ...grupo,
                    _chave: gerarChave(),
                    perguntas: (grupo.perguntas || []).map(pergunta => ({ ...pergunta, _chave: gerarChave(), opcoes: pergunta.opcoes || [] }))
                }))
            })
        })
    }, [id])

    // Reserva o espaço da barra de rolagem enquanto a tela estiver aberta, para a
    // página não "pular" ao trocar entre abas com alturas diferentes.
    useEffect(() => {
        const raiz = document.documentElement
        const anterior = raiz.style.scrollbarGutter
        raiz.style.scrollbarGutter = 'stable'
        return () => { raiz.style.scrollbarGutter = anterior }
    }, [])

    const alternarOpcoes = chave => setExpandidas({ ...expandidas, [chave]: !expandidas[chave] })

    const adicionarPergunta = helpers => {
        const nova = novaPergunta()
        helpers.push(nova)
        setExpandidas({ ...expandidas, [nova._chave]: true })
        setLinhaNova(nova._chave)

        setTimeout(() => {
            const linha = document.getElementById(idLinha(nova._chave))
            if (linha) {
                linha.scrollIntoView({ behavior: 'smooth', block: 'center' })
                const campo = linha.querySelector('input[type="text"]')
                campo && campo.focus({ preventScroll: true })
            }
        }, 50)
    }

    const Submit = (values) => {
        const grupos = values.grupos || []

        for (let gi = 0; gi < grupos.length; gi++) {
            const perguntas = grupos[gi].perguntas || []

            for (let pi = 0; pi < perguntas.length; pi++) {
                const pergunta = perguntas[pi]
                const opcoes = (pergunta.opcoes || []).filter(x => x && x.descricao && x.descricao.trim())

                if (!ehComentario(pergunta) && opcoes.length === 0) {
                    setAbaAtiva(gi)
                    setExpandidas({ ...expandidas, [pergunta._chave]: true })
                    mostrarToast('erro', `${grupos[gi].descricao || 'Grupo ' + (gi + 1)}, pergunta ${pi + 1}: informe ao menos uma opção de resposta.`)
                    return
                }
            }
        }

        setSalvando(true)

        salvar(
            {
                id: values.id,
                grupos: grupos.map((grupo, gi) => ({
                    id: grupo.id,
                    descricao: grupo.descricao,
                    ordem: gi + 1,
                    ativo: grupo.ativo === true,
                    perguntas: (grupo.perguntas || []).map((pergunta, pi) => ({
                        id: pergunta.id,
                        descricao: pergunta.descricao,
                        ordem: pi + 1,
                        tipo_pergunta: pergunta.tipo_pergunta,
                        placeholder: pergunta.placeholder,
                        mostrar_nao_possui: pergunta.mostrar_nao_possui === true,
                        ativo: pergunta.ativo === true,
                        opcoes: (pergunta.opcoes || []).filter(x => x && x.descricao && x.descricao.trim()).map((opcao, oi) => ({ id: opcao.id, descricao: opcao.descricao, ordem: oi + 1 }))
                    }))
                }))
            },
            '/preanestesico/formulario',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                props.history.push('/preanestesico/formulario/consulta')
            },
            () => setSalvando(false))
    }

    const removerPergunta = (helpers, pergunta, indice) =>
        setConfirmacao({
            mensagem: `Remover a pergunta "${pergunta.descricao || 'sem descrição'}"? Ela não possui respostas registradas e sai do formulário.`,
            aoConfirmar: () => helpers.remove(indice)
        })

    const removerGrupo = (helpers, grupo, indice, totalGrupos) => {
        const aoConfirmar = () => {
            helpers.remove(indice)
            setAbaAtiva(Math.max(0, Math.min(indice, totalGrupos - 2)))
        }

        if ((grupo.perguntas || []).length > 0)
            setConfirmacao({
                mensagem: `Remover o grupo "${grupo.descricao || 'sem descrição'}" e as ${grupo.perguntas.length} pergunta(s) dele? Nenhuma possui respostas registradas.`,
                aoConfirmar
            })
        else
            aoConfirmar()
    }

    // Desativar o grupo desativa as perguntas dele; ao reativar, o usuário escolhe se quer
    // trazer as perguntas junto ou ligar uma a uma.
    const alternarGrupo = (propsFormik, grupo, gi) => {
        const perguntas = grupo.perguntas || []
        const marcarPerguntas = ativo => perguntas.forEach((_, pi) => propsFormik.setFieldValue(`grupos[${gi}].perguntas[${pi}].ativo`, ativo))

        if (grupo.ativo === true) {
            const desativar = () => {
                propsFormik.setFieldValue(`grupos[${gi}].ativo`, false)
                marcarPerguntas(false)
            }

            const ativas = perguntas.filter(pergunta => pergunta.ativo === true).length

            if (ativas > 0)
                setConfirmacao({
                    mensagem: `Desativar o grupo "${grupo.descricao || 'sem descrição'}"? As ${ativas} pergunta(s) ativa(s) dele também serão desativadas.`,
                    textoConfirmar: 'Desativar',
                    aoConfirmar: desativar
                })
            else
                desativar()

            return
        }

        propsFormik.setFieldValue(`grupos[${gi}].ativo`, true)

        const inativas = perguntas.filter(pergunta => pergunta.ativo !== true).length

        if (inativas > 0)
            setConfirmacao({
                mensagem: `Grupo "${grupo.descricao || 'sem descrição'}" ativado. Deseja ativar também as ${inativas} pergunta(s) desativada(s) dele?`,
                textoConfirmar: 'Ativar todas',
                aoConfirmar: () => marcarPerguntas(true)
            })
    }

    const alternarPergunta = (propsFormik, gi, pi, ativo) =>
        propsFormik.setFieldValue(`grupos[${gi}].perguntas[${pi}].ativo`, ativo !== true)

    const erroNoGrupo = (propsFormik, gi) => propsFormik.submitCount > 0 && propsFormik.errors.grupos && propsFormik.errors.grupos[gi]

    const botaoAdicionarPergunta = helpers =>
        <button type='button' className='btn btn-primary primary btn-sm' onClick={() => adicionarPergunta(helpers)}>
            <span className='icon-Add mr-1'></span>Adicionar Pergunta
        </button>

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            validateOnChange={false}
            enableReinitialize={true}
            onSubmit={(values) => Submit(values)}>
            {propsFormik => {
                const grupos = propsFormik.values.grupos || []

                return (<Form>
                    <HeaderCadastro titulo={`Alteração do Formulário${propsFormik.values.descricao ? ' - ' + propsFormik.values.descricao : ''}`} link={links} />
                    <div className='card mb-20'>
                        <FieldArray name='grupos'>
                            {helpersGrupos => (
                                <Tabs style={{ backgroundColor: '#F8F8F8' }} selectedIndex={Math.min(abaAtiva, grupos.length)}
                                    onSelect={indice => {
                                        if (indice === grupos.length) {
                                            helpersGrupos.push(novoGrupo())
                                            setAbaAtiva(grupos.length)
                                            return false
                                        }
                                        setAbaAtiva(indice)
                                        return true
                                    }}>
                                    <TabList>
                                        {grupos.map((grupo, gi) =>
                                            <Tab key={grupo._chave} className={'react-tabs__tab' + (erroNoGrupo(propsFormik, gi) ? ' tab-error' : '')}>
                                                <span className='icone-tab icon-File-ClipboardFileText'></span>{grupo.descricao || `Grupo ${gi + 1}`}
                                                {grupo.ativo !== true && <small className='text-muted ml-1'>(desativado)</small>}
                                            </Tab>)}
                                        <Tab className='react-tabs__tab' title='Adicionar um novo grupo de perguntas'>
                                            <span className='icone-tab icon-Add'></span>Novo Grupo
                                        </Tab>
                                    </TabList>

                                    {grupos.map((grupo, gi) =>
                                        <TabPanel key={grupo._chave}>
                                            <div className='padding-40'>
                                                <div className='row'>
                                                    <CampoTexto label='Nome do Grupo' name={`grupos[${gi}].descricao`} obrigatorio={true} tamanho='col-lg-6' maxLength={100}
                                                        placeholder='Ex.: Avaliação Clínica' autoFocus={!grupo.id} />
                                                    <div className='col-lg-6 d-flex align-items-end justify-content-end mb-3 fpa-acoes'>
                                                        <div className='mr-3 pb-2'>
                                                            <InputCheckboxNullable twoOptions={true} name={`grupos[${gi}].ativo`} label={'Grupo ativo'}
                                                                title='Grupo desativado não aparece nas fichas novas'
                                                                onChange={() => alternarGrupo(propsFormik, grupo, gi)} />
                                                        </div>
                                                        <span className={'fpa-acao icon-Arrow-LeftinCircle' + (gi === 0 ? ' invisible' : '')} title='Mover grupo para antes'
                                                            onClick={() => { if (gi > 0) { helpersGrupos.move(gi, gi - 1); setAbaAtiva(gi - 1) } }}></span>
                                                        <span className={'fpa-acao icon-Arrow-RightinCircle' + (gi === grupos.length - 1 ? ' invisible' : '')} title='Mover grupo para depois'
                                                            onClick={() => { if (gi < grupos.length - 1) { helpersGrupos.move(gi, gi + 1); setAbaAtiva(gi + 1) } }}></span>
                                                        <span className={'fpa-acao fpa-remover icon-New-Trash' + (grupoTemResposta(grupo) ? ' invisible' : '')}
                                                            title='Remover grupo'
                                                            onClick={() => !grupoTemResposta(grupo) && removerGrupo(helpersGrupos, grupo, gi, grupos.length)}></span>
                                                    </div>
                                                </div>

                                                <FieldArray name={`grupos[${gi}].perguntas`}>
                                                    {helpersPerguntas => (
                                                        <>
                                                            <div className='display-flex row-space-between mb-3 mt-2'>
                                                                <h5 className='m-0'>Perguntas</h5>
                                                            </div>
                                                            <table className='table table-responsive-md table-striped tabela'>
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: '4%' }}>#</th>
                                                                        <th>Pergunta</th>
                                                                        <th style={{ width: '17%' }}>Tipo de Resposta</th>
                                                                        <th style={{ width: '8%' }} className='text-center'>Negativo</th>
                                                                        <th style={{ width: '10%' }} className='text-center'>Opções</th>
                                                                        <th style={{ width: '7%' }} className='text-center'>Ativa</th>
                                                                        <th style={{ width: '13%' }} className='text-center'>Ações</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {(grupo.perguntas || []).length > 0 ? grupo.perguntas.map((pergunta, pi) => {
                                                                        const comentario = ehComentario(pergunta)
                                                                        const aberta = !!expandidas[pergunta._chave]
                                                                        const travada = pergunta.qtd_respostas > 0

                                                                        return (
                                                                            <React.Fragment key={pergunta._chave}>
                                                                                <tr id={idLinha(pergunta._chave)} className={(linhaNova === pergunta._chave ? 'fpa-linha-nova' : '') + (pergunta.ativo === true ? '' : ' fpa-inativa')}>
                                                                                    <td style={{ verticalAlign: 'middle' }}>{pi + 1}</td>
                                                                                    <td>
                                                                                        <CampoTexto name={`grupos[${gi}].perguntas[${pi}].descricao`} maxLength={200} placeholder='Pergunta' tamanho='col-12 pl-0 pr-0 mb-0' />
                                                                                        <CampoTexto name={`grupos[${gi}].perguntas[${pi}].placeholder`} maxLength={100} placeholder='Texto de apoio da observação (opcional)' tamanho='col-12 pl-0 pr-0 mb-0 mt-1' />
                                                                                    </td>
                                                                                    <td>
                                                                                        <InputTipoPergunta name={`grupos[${gi}].perguntas[${pi}].tipo_pergunta`} propsFormik={propsFormik} placeholder='Tipo'
                                                                                            tamanho='col-12 pl-0 pr-0 mb-0' classeTooltip={'tooltip-input-modal'} isDisabled={travada} />
                                                                                        {travada && <small className='text-muted'>{pergunta.qtd_respostas} resposta(s) registrada(s)</small>}
                                                                                    </td>
                                                                                    <td className='text-center fpa-centro' style={{ verticalAlign: 'middle' }}>
                                                                                        <InputCheckboxNullable twoOptions={true} name={`grupos[${gi}].perguntas[${pi}].mostrar_nao_possui`} label={''} />
                                                                                    </td>
                                                                                    <td className='text-center' style={{ verticalAlign: 'middle' }}>
                                                                                        {comentario
                                                                                            ? <small className='text-muted'>—</small>
                                                                                            : <span style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} title={aberta ? 'Ocultar opções' : 'Exibir opções'} onClick={() => alternarOpcoes(pergunta._chave)}>
                                                                                                <b>{(pergunta.opcoes || []).length}</b> {aberta ? '▲' : '▼'}
                                                                                            </span>}
                                                                                    </td>
                                                                                    <td className='text-center fpa-centro' style={{ verticalAlign: 'middle' }}>
                                                                                        <InputCheckboxNullable twoOptions={true} name={`grupos[${gi}].perguntas[${pi}].ativo`} label={''}
                                                                                            disabled={grupo.ativo !== true}
                                                                                            title={grupo.ativo !== true ? 'Ative o grupo para liberar as perguntas' : 'Pergunta desativada não aparece nas fichas novas'}
                                                                                            onChange={() => alternarPergunta(propsFormik, gi, pi, pergunta.ativo)} />
                                                                                    </td>
                                                                                    <td className='text-center fpa-acoes' style={{ verticalAlign: 'middle' }}>
                                                                                        <span className={'fpa-acao icon-Arrow-UpinCircle' + (pi === 0 ? ' invisible' : '')} title='Mover para cima'
                                                                                            onClick={() => pi > 0 && helpersPerguntas.move(pi, pi - 1)}></span>
                                                                                        <span className={'fpa-acao icon-Arrow-DowninCircle' + (pi === grupo.perguntas.length - 1 ? ' invisible' : '')} title='Mover para baixo'
                                                                                            onClick={() => pi < grupo.perguntas.length - 1 && helpersPerguntas.move(pi, pi + 1)}></span>
                                                                                        <span className={'fpa-acao fpa-remover icon-New-Trash' + (travada ? ' invisible' : '')} title='Remover pergunta'
                                                                                            onClick={() => !travada && removerPergunta(helpersPerguntas, pergunta, pi)}></span>
                                                                                    </td>
                                                                                </tr>
                                                                                {aberta && !comentario &&
                                                                                    <tr>
                                                                                        <td colSpan={7} className='pl-5'>
                                                                                            <FieldArray name={`grupos[${gi}].perguntas[${pi}].opcoes`}>
                                                                                                {helpersOpcoes => (
                                                                                                    <div className='pb-2'>
                                                                                                        <div className='mb-2'>
                                                                                                            <b>Opções de resposta</b>
                                                                                                        </div>
                                                                                                        <table className='table table-sm mb-0'>
                                                                                                            <tbody>
                                                                                                                {(pergunta.opcoes || []).length > 0 ? pergunta.opcoes.map((opcao, oi) =>
                                                                                                                    <tr key={oi}>
                                                                                                                        <td style={{ width: '4%', verticalAlign: 'middle' }}>{oi + 1}</td>
                                                                                                                        <td>
                                                                                                                            <CampoTexto name={`grupos[${gi}].perguntas[${pi}].opcoes[${oi}].descricao`} maxLength={120} placeholder='Descrição da opção' tamanho='col-12 pl-0 pr-0 mb-0' />
                                                                                                                        </td>
                                                                                                                        <td style={{ width: '14%', verticalAlign: 'middle' }} className='text-center fpa-acoes'>
                                                                                                                            <span className={'fpa-acao icon-Arrow-UpinCircle' + (oi === 0 ? ' invisible' : '')} title='Mover para cima'
                                                                                                                                onClick={() => oi > 0 && helpersOpcoes.move(oi, oi - 1)}></span>
                                                                                                                            <span className={'fpa-acao icon-Arrow-DowninCircle' + (oi === pergunta.opcoes.length - 1 ? ' invisible' : '')} title='Mover para baixo'
                                                                                                                                onClick={() => oi < pergunta.opcoes.length - 1 && helpersOpcoes.move(oi, oi + 1)}></span>
                                                                                                                            <span className='fpa-acao fpa-remover icon-New-Trash' title='Remover opção'
                                                                                                                                onClick={() => helpersOpcoes.remove(oi)}></span>
                                                                                                                        </td>
                                                                                                                    </tr>)
                                                                                                                    : <tr><td colSpan={3} className='text-center text-muted'>Nenhuma opção. Perguntas de múltipla ou única escolha precisam de ao menos uma.</td></tr>}
                                                                                                            </tbody>
                                                                                                        </table>
                                                                                                        <div className='direita mt-2'>
                                                                                                            <button type='button' className='btn btn-primary primary btn-sm' onClick={() => helpersOpcoes.push(novaOpcao())}>
                                                                                                                <span className='icon-Add mr-1'></span>Adicionar Opção
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </FieldArray>
                                                                                        </td>
                                                                                    </tr>}
                                                                            </React.Fragment>
                                                                        )
                                                                    }) : <tr><td colSpan={6} className='text-center'>Nenhuma pergunta neste grupo. Clique em "Adicionar Pergunta".</td></tr>}
                                                                </tbody>
                                                            </table>
                                                            <div className='direita'>
                                                                {botaoAdicionarPergunta(helpersPerguntas)}
                                                            </div>
                                                        </>
                                                    )}
                                                </FieldArray>
                                            </div>
                                        </TabPanel>)}
                                    <TabPanel></TabPanel>
                                </Tabs>
                            )}
                        </FieldArray>
                    </div>

                    <div className='separator mt-40 mb-5'></div>
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Salvar' disabled={salvando} idTooltip={'salvar'} />
                    </div>

                    <ModalDuasOpcoes showModal={!!confirmacao} setShowModal={aberto => { if (!aberto) setConfirmacao(null) }}
                        funcaoOpcao1={() => setConfirmacao(null)}
                        funcaoOpcao2={() => { const acao = confirmacao && confirmacao.aoConfirmar; setConfirmacao(null); acao && acao() }}
                        esconderFechar mensagem={<>{confirmacao ? confirmacao.mensagem : ''}</>}
                        textoOpcao1={'Cancelar'}
                        classeOpcao1={'btn-sm btn-primary-modal simples'}
                        textoOpcao2={(confirmacao && confirmacao.textoConfirmar) || 'Continuar'} />
                </Form>)
            }}
        </Formik>
    )
}

export default Cadastro
